import { Button, Card } from '@common/components';
import { Flex, Text } from '@mantine/core';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { MultiFactorProgress, SemiCircleProgress } from 'src/components/progressBars';
import { PATHS } from 'src/constants';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';

interface ComplianceScoreCardProps {
  complianceLevel: string | undefined;
  complianceScore: number | undefined;
  description: string | undefined;
  number_passed: number | undefined;
  cant_tested :number | undefined;
  number_that_fails :number | undefined;
  colors?:Array<string>
}

const ComplianceScoreCard: FC<ComplianceScoreCardProps> = ({ complianceLevel, complianceScore, description , number_passed , cant_tested , number_that_fails,colors }) => {
  const [t] = useTranslation('accessibilityDashboard');
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const siteUUID = searchParams.get('siteUUID')
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const handleCheckIssuesButton = (): void => {
    navigate(`${PATHS.DASHBOARD}/${id}/issues/automated-audit?siteUUID=${siteUUID}`);
  };
  const handleAutomatedAuditButton = (): void => {
    navigate(`${PATHS.DASHBOARD}/${id}/${PATHS.AUTOMATED_AUDIT}`);
  };
  return (
    // <Card className={styles.outerCard}>
       
        <Flex h={'100%'} mih={isMobile ? 130 : 435} direction="column"  className={styles.card}>
          <MultiFactorProgress
            number_passed={number_passed ?? 0 }
            cant_tested={cant_tested ?? 0}
            number_that_fails={number_that_fails ?? 0}
            // title= {isMobile ? t('ialabsScoreTitleMobile') : t('ialabsScoreTitle')}
            colors={colors ?? []}
            
          />
          {/* <Text weight={isMobile ? 400 : 700} py={isMobile ? 8 : 24} style={{ textAlign: 'center'}}>
            {t('complianceScoreLevelText')} {complianceLevel}
          </Text> */}
        </Flex>
      // ) : (
      //   <Fragment>
      //     <Text weight="bold" py={24}>
      //       {t('complianceDataNotReceivedText')}
      //     </Text>
      //     <Button onClick={handleAutomatedAuditButton} small={isMobile ? true : false}>
      //       {t('automatedAuditButtonText')}
      //     </Button>
      //   </Fragment>
      // )
    // </Card>
  );
};

export default ComplianceScoreCard;
